import { render, staticRenderFns } from "./SingleBlogPage.vue?vue&type=template&id=23eedd1e&"
import script from "./SingleBlogPage.vue?vue&type=script&lang=js&"
export * from "./SingleBlogPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports